// extracted by mini-css-extract-plugin
export default {"root":"gift_card_store_booking_page_root__aOxUn"};